
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/meta-description-generator",
      function () {
        return require("private-next-pages/app/tools/meta-description-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/meta-description-generator"])
      });
    }
  